import { ITaskScopedFact, ITimestampedFact } from './common';

export interface ITaskCompletedFact extends ITaskScopedFact, ITimestampedFact {
  isOverdue: boolean;
  overdueBy?: number;
}
